import { InjectionToken } from '@angular/core';

/**
 * Holds all configuration values for this app
 *
 * @type {bbject}
 */
export const appConfigValues = new InjectionToken<Map<string,string>>('Configuration - App Config Values');